import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { DriverState } from '../../../../shared/constants/enums/driver-state.enum';
import { DriverManagementService } from '../../../../shared/services/driver-management.service';
import { NgClass, AsyncPipe } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-select-avatar',
    templateUrl: './select-avatar.component.html',
    styleUrls: ['./select-avatar.component.scss', '../../../../../../../common-module/src/lib/app-styles/dialog-common.scss'],
    imports: [NgClass, MatButton, AsyncPipe, TranslateModule]
})

export class SelectAvatarComponent implements OnInit {

  public avatarList$: Observable<string[]>;
  public isPreviousStateEdit = false;
  public selectedAvatar: string;

  constructor(private driverManagementService: DriverManagementService) {
  }

  ngOnInit(): void {
    this.avatarList$ = this.driverManagementService.avatarList$;
    this.selectedAvatar = this.driverManagementService.tempDriver?.avatarUrl;
    this.isPreviousStateEdit = this.driverManagementService.getPreviousState() === DriverState.EDIT;
  }

  public onCancel(): void {
    this.driverManagementService.changeState();
  }

  public onSelect(avatar: string): void {
    this.driverManagementService.tempAvatar = avatar;
    this.driverManagementService.changeState();
  }
}
